module.exports = __webpack_public_path__ + "static/fleishman-is-in-trouble-4831b2a04c4d2aa9a0b07a62cf6761df.jpg";